<script>
import NavigateMixin from '@/src/mixins/navigate-mixin.vue'
import { healthCard } from './health-help-data'
import layout from '@src/mixins/layout.vue'
import * as _ from 'lodash'

export default {
  page: {
    title: 'Health-help',
    meta: [{ name: 'description', content: 'The Health-help page.' }],
  },
  mixins: [layout, NavigateMixin],
  data() {
    return {
      cards: _.cloneDeep(healthCard),
      orgName: null,
    }
  },
  watch: {
    cards(newValue) {
      return newValue
    },
  },
  methods: {
    openTab(moveUrl) {
      window.open(moveUrl)
    },
    handleNavigation(service) {
      if (service.isActivationPending || service.isComingSoon) {
        return false
      } else {
        service.title === 'Watch videos' ||
        service.title === 'Read articles' ||
        service.title === 'Health Checker' ||
        service.title === 'Talk with Serea'
          ? this.openTab(service.url)
          : this.navigateToScreen(service.url)
      }
    },
  },
}
</script>

<template>
  <v-container fluid>
    <div :class="$style.containwrap">
      <div :class="$style.pageTitle">
        <v-avatar class="mb-2 mr-2">
          <v-img
            width="20"
            :src="
              require('@assets/images/safehaven/health-help/HBHelp-gradient.svg')
            "
          ></v-img
        ></v-avatar>
        <span :class="$style.pageTitle"> HB+ Help</span>
      </div>
      <p :class="$style.pageDesc"
        >HealthBook+ provides innovative health tools and insightful resources
        to address your health needs.
        <span :class="$style.boldText"
          >If you have an emergency, please call 911.</span
        ></p
      >
      <v-row dense>
        <v-col
          v-for="item in cards"
          :key="item.title"
          cols="12"
          xs="12"
          sm="6"
          md="4"
          lg="4"
          xl="4"
          class="mt-0"
        >
          <v-card class="mr-1 my-1 pt-8 pa-2" :class="$style.cardStyle">
            <v-img height="150" contain :src="item.img"></v-img>
            <v-card-title class="justify-center">{{ item.title }}</v-card-title>
            <v-card-text>{{ item.description }}</v-card-text>

            <div
              v-for="(service, index) in item.services"
              :key="service.title"
              class="pa-2"
            >
              <v-divider :key="index" class="mb-2"></v-divider>
              <div
                class="d-flex align-top"
                :class="$style.serviceSection"
                @click="handleNavigation(service)"
              >
                <v-avatar class="mr-2">
                  <v-img :src="service.img"></v-img>
                </v-avatar>
                <div>
                  <div
                    :class="
                      service.isActivationPending || service.isComingSoon
                        ? $style.servicePendingTitle
                        : $style.serviceTitle
                    "
                    >{{ service.title }}
                    <span
                      v-if="service.isActivationPending"
                      :class="$style.italicText"
                    >
                      - Pending Activation</span
                    ><span
                      v-if="service.isComingSoon"
                      :class="$style.italicText"
                    >
                      - Coming Soon</span
                    ></div
                  >
                  <div :class="$style.serviceDesc">
                    {{ service.description }}
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <p :class="['mt-4 text-left', $style.pageDesc]"
        >HealthBook+ provides information to help guide your next action based
        on available data about your symptoms and conditions. HealthBook+ does
        not provide a medical diagnosis and should not replace licensed
        healthcare practitioners. If you have any questions or concerns about
        the results of HealthBook+, consult your licensed healthcare
        practitioner.</p
      >
    </div>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.boldText {
  font-weight: 700;
}

.cardStyle {
  width: 100%;
  height: 100%;
  border: 1px solid #93c0e8 !important;
  box-shadow: none !important;
}

.italicText {
  font-style: italic;
  font-weight: normal;
  color: #7a7a7a;
}

.servicePendingTitle {
  font-size: 14px;
  font-weight: 700;
  color: #7a7a7a;
}
.pageTitle {
  margin-top: 20px !important;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 700;
  color: #3d3d3d;
}

.pageDesc {
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #3d3d3d;
}

.containwrap {
  padding-left: 40px;
  text-align: left;
}

.serviceTitle {
  font-size: 14px;
  font-weight: 700;
  color: #057cfc;
}

.serviceDesc {
  font-size: 14px;
  font-weight: 500;
  color: #7a7a7a;
}

.serviceSection {
  cursor: pointer;
}

@media screen and (max-width: 959px) {
  .containwrap {
    padding-left: inherit;
  }

  .pageTitle {
    text-align: center;
  }

  .pageDesc {
    text-align: center;
  }
}
</style>
